
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SidePanel extends Vue {
  @Prop(String) readonly width: string | undefined;
  @Prop({ default: true }) readonly defaultShadow!: boolean;
}
